import { createDynamicMiddleware, configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from "redux-persist"
import storage from "redux-persist/lib/storage"
import authReducer from "../slices/usuario"


const userPersistConfig = {
  key: "user",
  storage,
  version: 0
}


const userPersistedReducer = persistReducer(userPersistConfig, authReducer)
const dynamicMiddleware = createDynamicMiddleware()

export const store = configureStore({
  reducer: {
    auth: userPersistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(dynamicMiddleware.middleware),
})

export const persistor = persistStore(store)
